// ==============================================================
// web socket functions

//import { ref } from "vue";
import Vue from "vue";

// ==============================================================
const ws1host = "wss://wss.mrsdigi.com:8080/notify";

var vm = new Vue({ data: { wsConnect: undefined, wsOnline: false, wsRecon: 0 } });

// ==============================================================
export const sleep = ms => new Promise(r => setTimeout(r, ms));

export const wsReadyState = () =>
  vm.wsConnect === undefined
    ? null
    : vm.wsConnect.readyState !== WebSocket.CLOSED && vm.wsConnect.readyState !== WebSocket.CLOSING;
export const wsOnlineState = () => {
  return vm.wsConnect === undefined ? false : vm.wsOnline;
};
export const wsReconReq = () => vm.wsRecon > 0 && (vm.wsConnect === undefined || !vm.wsOnline);

// ==============================================================
export const wsCheckTryReConnect = () => {
  if (wsOnlineState() == false || wsReadyState() == false) {
    vm.wsRecon++;
  }
};

// ==============================================================
export async function wsOpen(cb = undefined) {
  vm.wsRecon = 0;
  // close prev connection if any
  if (vm.wsConnect) {
    vm.wsConnect.close();
  }
  vm.wsConnect = new WebSocket(ws1host);
  // onopen, onclose, onmessage, onerror, send(message)
  vm.wsConnect.onopen = (/*event: any*/) => {
    console.log("websocket connected");
    vm.wsOnline = true;
    if (cb) cb();
  };
  vm.wsConnect.onclose = (/*event*/) => {
    vm.wsOnline = false;
    console.log("websocket disconnected");
  };
  vm.wsConnect.onmessage = event => {
    try {
      handleMessage(event);
    } catch (e) {
      console.log(e);
    }
  };
  vm.wsConnect.onerror = err => {
    console.log("'websocket error: " + err.message + ".  closing ...");
    wsClose();
  };
}

// ==============================================================
export function wsClose() {
  vm.wsOnline = false;
  if (vm.wsConnect) {
    vm.wsConnect.close();
    vm.wsConnect = undefined;
  }
}

// ==============================================================
// ==============================================================
const channelMap = new Map();
let _listCallback = () => {};
// ==============================================================
export function wsSubscribe(topic, cb) {
  if (vm.wsOnline && vm.wsConnect) {
    channelMap.set(topic, cb);
    vm.wsConnect.send('{"subscribe":["' + topic + '"]}');
    return true;
  } else {
    return false;
  }
}

// ==============================================================
export function wsList(/*topic, cb*/) {
  if (vm.wsOnline && vm.wsConnect) {
    vm.wsConnect.send('{"list":true}');
    return true;
  } else {
    return false;
  }
}

// ==============================================================
// ==============================================================
function handleMessage(event) {
  let obj = JSON.parse(event.data);
  if (obj && obj.action) {
    if (obj.action == "notify") {
      if (obj.channel) {
        let cbFunc = channelMap.get(obj.channel);
        if (cbFunc) {
          cbFunc(obj.data);
        }
      } else {
        console.log("notify (no channel) ", obj);
      }
    } else if (obj.action == "list") {
      if (_listCallback) _listCallback(obj.data);
    }
  } else {
    console.log("(no action) ", obj);
  }
}

// ==============================================================
// ==============================================================
// checking page visible or not
// based on https://developer.chrome.com/blog/page-lifecycle-api/
const getState = () => (document.visibilityState === "hidden" ? "hidden" : document.hasFocus() ? "active" : "passive");
let curState = getState();
let _wasSuspended = false;
const stateChanged = nextState => {
  if (nextState !== curState) {
    if (nextState == "active") {
      // App is resuming from background/suspension
      if (_wasSuspended) {
        _wasSuspended = false;
        // Verify the Vue app is still mounted and not a white screen
        const appEl = document.getElementById("app");
        if (!appEl || !appEl.innerHTML || appEl.innerHTML.trim() === "") {
          console.warn("[wsNotify] App appears unmounted after suspension, reloading...");
          window.location.reload();
          return;
        }
        // Re-initialize critical connections after suspension
        setTimeout(() => {
          wsCheckTryReConnect();
          // Dispatch custom event so App.vue can refresh data/IndexedDB
          document.dispatchEvent(new CustomEvent("appResumed"));
        }, 2000);
      } else {
        setTimeout(() => wsCheckTryReConnect(), 2000);
      }
    }
    curState = nextState;
  }
};
// Handle pageshow specifically for iOS BF cache / WKWebView resume
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    // Page was restored from browser cache (BF cache) or WKWebView suspension
    const appEl = document.getElementById("app");
    if (!appEl || !appEl.innerHTML || appEl.innerHTML.trim() === "") {
      console.warn("[wsNotify] App unmounted after page cache restore, reloading...");
      window.location.reload();
      return;
    }
  }
  stateChanged(getState());
}, { capture: true });
["focus", "blur", "visibilitychange", "resume"].forEach(type => {
  window.addEventListener(type, () => stateChanged(getState()), { capture: true });
});
window.addEventListener("freeze", () => {
  _wasSuspended = true;
  stateChanged("frozen");
}, { capture: true });
window.addEventListener("pagehide", e => {
  _wasSuspended = true;
  if (e.persisted) stateChanged("frozen");
  else stateChanged("terminated");
}, {
  capture: true,
});
